<section class="apps pb-0" id="apps">
    <div class="container">
      <div class="apps-inner">
        <div class="side pb-5">
          <div class="title" i18n="home dpApps: title">Over <span class="position-relative" style="font-family: 'Poppins Bold';">1.5 Million<img class="position-absolute"
            style="left: 0;
      bottom: -14px;
      width: 100%;" src="./assets/lines/3.png" alt=""></span> app downloads</div>
          <div class="available-block">
            <div class="sub-title"  i18n="home dpApps: available on">Available on,</div>
            <div class="devices d-flex align-items-start">
              <div class="device">
                <img src="./assets/icons/devices/1.png" alt="">
                <div class="name"  i18n="home dpApps: mobile">Mobiles</div>
                <div class="info"  i18n="home dpApps: android and ios">Android & IOS</div>
              </div>
              <div class="device">
                <img src="./assets/icons/devices/2.png" alt="">
                <div class="name" i18n="home dpApps: desktops">Desktops</div>
                <div class="info" i18n="home dpApps: all browsers">All Browsers</div>
              </div>
              <div class="device">
                <img src="./assets/icons/devices/3.png" alt="">
                <div class="name" i18n="home dpApps: tablets">Tablets</div>
                <div class="info" i18n="home dpApps: android and ipad">Android & iPad</div>
              </div>
            </div>
          </div>
          <div class="download-links pb-md-5">
            <a href="https://play.google.com/store/apps/details?id=lk.databoxtech.dpeducation">
              <img src="./assets/images/fancy/googleplay.png" alt="Google Play Logo">
            </a>
            <a href="https://apps.apple.com/us/app/dp-education/id1574530050">
              <img src="./assets/images/fancy/appstore_badge.png" alt="appstore Logo">
            </a>
            <a href="https://appgallery.huawei.com/#/app/C104504493">
              <img src="./assets/images/fancy/appgallery_badge.png" alt="huawei Logo">
            </a>
            <a href="https://apps.microsoft.com/store/detail/dp-education/9MV20P2NV5HP?hl=si-lk&gl=lk">
              <img src="./assets/images/fancy/winstore_badge.png" alt="windows Logo">
            </a>
          </div>
        </div>
        <div class="side fancy">
          <img width="100%" src="./assets/images/fancy/apps.png" alt="Screenshot Image">
        </div>
      </div>
    </div>
  </section>